module.exports = __webpack_public_path__ + "img/purpose_3.ae2dac51.png";